export default "__VITE_ASSET__DBvZcuWh__"